/**
 * Attempt to parse a potentially incomplete JSON string.
 * If the string is valid JSON, returns the parsed object.
 * If incomplete, tries patching by closing open strings and braces.
 * Returns null if unparseable.
 */
export function parsePartialJson(json: string): any | null {
    try {
        return JSON.parse(json);
    } catch {
        try {
            let patched = json.replace(/,\s*$/, "");
            // Count unescaped quotes to detect open strings
            const unescapedQuotes = patched.match(/(?<!\\)"/g);
            const isStringOpen =
                unescapedQuotes && unescapedQuotes.length % 2 !== 0;
            if (isStringOpen) {
                patched += '"';
            }
            patched += "}";
            return JSON.parse(patched);
        } catch {
            return null;
        }
    }
}
